import React from "react";
import "./LeaderShip.css";
import OurTeam from "../AboutUs/OurTeam/OurTeam";
import Founder from "../AboutUs/Founder/Founder";
import Founder_Modal from "../Common_Component/Founder_Modal/Founder_Modal";

function LeaderShip({
  modalImgSrc,
  ModalNameText,
  modalSubHeadingText,
  modalHeadingText,
  ModalDescriptionText,
}) {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <section className="LeaderShip">
        <div className="">
          {/* <div className="ceo_holder">
            <Founder
              className="main_founder"
              knowMore={
                <>
                  <div className="Know-more-holder">
                    <p>More to Know</p>
                    <div
                      className="apply-btn"
                    // onClick={() => setModalShow(true)}
                    >
                      <img
                        className="arrow_up_right_img"
                        src={
                          process.env.PUBLIC_URL +
                          "/Assets/Images/Career/Collaborative_Culture/arrow_up_right.png"
                        }
                      />
                    </div>
                  </div>
                </>
              }
              imgSrc={"/Assets/Images/AboutUs/Founder/mohit.png"}
              nametext={"Mr. Mohit Tilekar"}
              subHeading={"- CEO  & MD"}
              subHeadingTwo={"The Unstoppable Visionary Behind"}
              headingText={" RechOut Media Tech"}
              discriptiontext={
                <>
                  <p>
                    Born into a family rooted in screen printing, Mr. Mohit
                    Tilekar, CEO and Managing Director of RechOut Media Tech
                    Pvt. Ltd., grew up witnessing the dedication and struggles
                    of his parents in running a modest printing business. Even
                    as a young boy, he carried the weight of their challenges
                    while nurturing a dream to transform their efforts into
                    something extraordinary.
                  </p>

                  <p>
                    By the time he was in 4th standard, Mr. Tilekar began
                    assisting in the family business, learning its nuances and
                    developing a deep connection to the industry. Despite
                    financial hardships and numerous setbacks, he immersed
                    himself fully by 9th standard, determined to overcome every
                    obstacle with unwavering resolve.
                  </p>

                  <p>
                    By the time he was in 4th standard, Mr. Tilekar began
                    assisting in the family business, learning its nuances and
                    developing a deep connection to the industry. Despite
                    financial hardships and numerous setbacks, he immersed
                    himself fully by 9th standard, determined to overcome every
                    obstacle with unwavering resolve.
                  </p>
                </>
              }
              modalImgSrc={"/Assets/Images/AboutUs/Founder/mohit.png"}
              ModalNameText={"Mr. Mohit Tilekar"}
              modalSubHeadingText={"- CEO  & MD"}
              // modalHeadingText={"RechOut Media Tech"}
              ModalDescriptionText={
                <>
                  <p>
                    Born into a family rooted in screen printing, Mr. Mohit
                    Tilekar, CEO and Managing Director of RechOut Media Tech
                    Pvt. Ltd., grew up witnessing the dedication and struggles
                    of his parents in running a modest printing business. Even
                    as a young boy, he carried the weight of their challenges
                    while nurturing a dream to transform their efforts into
                    something extraordinary.
                  </p>

                  <p>
                    By the time he was in 4th standard, Mr. Tilekar began
                    assisting in the family business, learning its nuances and
                    developing a deep connection to the industry. Despite
                    financial hardships and numerous setbacks, he immersed
                    himself fully by 9th standard, determined to overcome every
                    obstacle with unwavering resolve.
                  </p>

                  <p>
                    By the time he was in 4th standard, Mr. Tilekar began
                    assisting in the family business, learning its nuances and
                    developing a deep connection to the industry. Despite
                    financial hardships and numerous setbacks, he immersed
                    himself fully by 9th standard, determined to overcome every
                    obstacle with unwavering resolve.
                  </p>
                </>
              }
            />
          </div> */}

          <Founder
            className="sub_founder"
            imgSrc={"/Assets/Images/AboutUs/Founder/mahavir.png"}
            nametext={"Mr. Mahavir Mutha  "}
            subHeading={"- CEO"}
            headingSubText={
              <>
                <p>
                  A visionary leader with a journey that exemplifies
                  determination, resilience, and passion for excellence.{" "}
                </p>

                <p>
                  Born into a humble middle-class family, Mr. Mutha embraced the
                  challenges of life early, stepping into the business world at
                  the young age of 17. His journey was marked by trials and
                  triumphs, navigating through ups and downs that shaped his
                  perspective and honed his entrepreneurial spirit.
                </p>
              </>
            }
            // headingText={"RechOut Media Tech"}
            discriptiontext={
              <>
                <p>
                  In 2007, he shifted gears and entered the corporate world,
                  gaining invaluable experience by serving in multiple
                  industries. This phase became a cornerstone of his career,
                  allowing him to understand diverse business landscapes and
                  sharpen his marketing expertise.
                </p>

                <p>
                  In 2015, Mr. Mutha transitioned into the real estate sector,
                  focusing on marketing, where he truly thrived. With unwavering
                  confidence and a deep understanding of market dynamics, he
                  quickly made his mark, driving remarkable growth and success.
                </p>

                <p>
                  Today, as a seasoned leader, Mr. Mahaveer Mutha brings a
                  wealth of experience across various industries and an
                  unparalleled insight into all facets of the marketing sector.
                  His story is a testament to how dedication, adaptability, and
                  self-belief can transform challenges into opportunities.
                </p>

                <p>
                  Under his guidance, ReachOut Media Tech Pvt. Ltd. is not just
                  a company—it’s a movement to redefine advertising and
                  marketing, powered by the lessons and expertise of its
                  accomplished leaders
                </p>
              </>
            }
            modalImgSrc={"/Assets/Images/AboutUs/Founder/mahavir.png"}
            ModalNameText={"Mr. Mahavir Mutha "}
            modalSubHeadingText={"-  CEO"}
            // modalHeadingText={"RechOut Media Tech"}
            ModalDescriptionText={
              <>
                <p>
                  In 2007, he shifted gears and entered the corporate world,
                  gaining invaluable experience by serving in multiple
                  industries. This phase became a cornerstone of his career,
                  allowing him to understand diverse business landscapes and
                  sharpen his marketing expertise.
                </p>

                <p>
                  In 2015, Mr. Mutha transitioned into the real estate sector,
                  focusing on marketing, where he truly thrived. With unwavering
                  confidence and a deep understanding of market dynamics, he
                  quickly made his mark, driving remarkable growth and success.
                </p>

                <p>
                  Today, as a seasoned leader, Mr. Mahaveer Mutha brings a
                  wealth of experience across various industries and an
                  unparalleled insight into all facets of the marketing sector.
                  His story is a testament to how dedication, adaptability, and
                  self-belief can transform challenges into opportunities.
                </p>

                <p>
                  Under his guidance, ReachOut Media Tech Pvt. Ltd. is not just
                  a company—it’s a movement to redefine advertising and
                  marketing, powered by the lessons and expertise of its
                  accomplished leaders
                </p>
              </>
            }
          />

          {/* <Founder
            className="sub_founder"
            imgSrc={"/Assets/Images/AboutUs/Founder/sumit.png"}
            nametext={"Mr. Sumit Vijay Girme   "}
            subHeading={"- MD"}
            headingSubText={
              <>
                <p>
                  A dynamic leader whose journey reflects perseverance,
                  ambition, & an unwavering drive to succeed.{" "}
                </p>

                <p>
                  Hailing from a humble middle-class family, Mr. Girme’s story
                  is one of grit & determination. He laid the foundation for his
                  professional path by pursuing B.E. in Production, equipping
                  himself with strong technical and analytical skills.
                </p>
              </>
            }
            // headingText={"RechOut Media Tech"}
            discriptiontext={
              <>
                <p>
                  He began his professional career as a Technical Associate at
                  John Deere, where he honed his technical expertise and
                  developed a strong foundation for the corporate world. Later,
                  he advanced to become a Senior Associate at WNS, gaining
                  valuable experience in global operations & problem-solving.
                </p>

                <p>
                  Not one to settle, Mr. Girme ventured into entrepreneurship,
                  starting his own consultancy firm, specializing in Government
                  and Private Tender Consultancy. This bold step allowed him to
                  assist businesses in navigating intricate tendering processes,
                  showcasing his strategic thinking & leadership skills.
                </p>

                <p>
                  Now, as a co-founder of ReachOut Media Tech Pvt. Ltd., Mr.
                  Girme brings his entrepreneurial spirit and vast experience to
                  the forefront. His vision is to revolutionize the advertising
                  industry by offering 360° advertising solutions that help
                  brands connect with their audiences effectively and
                  creatively.
                </p>

                <p>
                  Mr. Sumit Girme’s journey is a shining example of hard work,
                  adaptability, and entrepreneurial zeal. Under his leadership,
                  ReachOut Media Tech Pvt. Ltd. is poised to set new benchmarks
                  in advertising and marketing, delivering innovative solutions
                  and driving meaningful results for businesses.
                </p>
              </>
            }
            modalImgSrc={"/Assets/Images/AboutUs/Founder/sumit.png"}
            ModalNameText={"Mr. Sumit Vijay Girme "}
            modalSubHeadingText={"- MD"}
            // modalHeadingText={"RechOut Media Tech"}
            ModalDescriptionText={<></>}
          /> */}

          <Founder
            className="sub_founder"
            imgSrc={"/Assets/Images/AboutUs/Founder/everest.png"}
            nametext={"Mr. Everest Deshmukh "}
            subHeading={"- COO"}
            headingSubText={
              <>
                <p>
                  A dynamic leader whose journey exemplifies hard work,
                  humility, and an unwavering commitment to excellence. Hailing
                  from a middle-class family with strong values instilled by his
                  father, a respected teacher, Mr. Deshmukh learned early in
                  life the importance of education and perseverance.
                </p>

                <p>
                  <b>
                    After completing his graduation, he began his professional
                    journey in Pune in 1996
                  </b>
                </p>
              </>
            }
            // headingText={"RechOut Media Tech"}
            discriptiontext={
              <>
                <p>
                  By 1997, he ventured into the automobile sector, establishing
                  dealerships for some of the most renowned companies in the
                  industry. Through sheer dedication and a relentless pursuit of
                  quality, Mr. Deshmukh built a remarkable reputation, becoming
                  a trusted name in the automobile world.
                </p>

                <p>
                  His journey is a testament to his hands-on approach and
                  humility. In the late 90s, when marketing was still evolving,
                  he personally distributed pamphlets across neighbourhoods to
                  promote his business. This grounded mindset and determination
                  to succeed became the foundation of his entrepreneurial
                  success.
                </p>

                <p>
                  Expanding his horizons, Mr Deshmukh later ventured into the
                  real estate industry as a builder, carving a niche for himself
                  in this competitive sector. His ability to adapt, innovate,
                  and lead by example has been instrumental in driving his
                  businesses to great heights.
                </p>

                <p>
                  Today, Mr. Everest Deshmukh stands as a visionary director of
                  ReachOut Media Tech Pvt. Ltd., bringing his decades of
                  expertise, grounded values, and entrepreneurial spirit to
                  inspire & steer the company toward unparalleled success.
                </p>
              </>
            }
            modalImgSrc={"/Assets/Images/AboutUs/Founder/everest.png"}
            ModalNameText={"Mr. Everest Deshmukh "}
            modalSubHeadingText={"- COO"}
            // modalHeadingText={"RechOut Media Tech"}
            ModalDescriptionText={
              <>
                <p>
                  A dynamic leader whose journey exemplifies hard work,
                  humility, and an unwavering commitment to excellence. Hailing
                  from a middle-class family with strong values instilled by his
                  father, a respected teacher, Mr. Deshmukh learned early in
                  life the importance of education and perseverance.
                </p>

                <p>
                  <b>
                    After completing his graduation, he began his professional
                    journey in Pune in 1996
                  </b>
                </p>

                <p>
                  renowned companies in the industry. Through sheer dedication
                  and a relentless pursuit of quality,
                </p>

                <p>
                  His journey is a testament to his hands-on approach and
                  humility. In the late 90s, when marketing was still evolving,
                  he personally distributed pamphlets across neighbourhoods to
                  promote his business. This grounded mindset and determination
                  to succeed became the foundation of his entrepreneurial
                  success.
                </p>

                <p>
                  Expanding his horizons, Mr Deshmukh later ventured into the
                  real estate industry as a builder, carving a niche for himself
                  in this competitive sector. His ability to adapt, innovate,
                  and lead by example has been instrumental in driving his
                  businesses to great heights.
                </p>

                <p>
                  Today, Mr. Everest Deshmukh stands as a visionary director of
                  ReachOut Media Tech Pvt. Ltd., bringing his decades of
                  expertise, grounded values, and entrepreneurial spirit to
                  inspire & steer the company toward unparalleled success.
                </p>
              </>
            }
          />
        </div>
      </section>

      <Founder_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalImgSrc={modalImgSrc}
        ModalNameText={ModalNameText}
        modalSubHeadingText={modalSubHeadingText}
        modalHeadingText={modalHeadingText}
        ModalDescriptionText={ModalDescriptionText}
      />
    </>
  );
}

export default LeaderShip;
